<script lang="ts">

import { onMount } from 'svelte';

type SearchResult = {
	count: number,
	vins: string[],
};

let result: SearchResult;

type BodyCriteria = {
	coupe: boolean,
	spider: boolean,
}

type EditionCriteria = {
	base,
	launchEdition,
	italia,
	stradaleTributo,
}

type ExteriorColorCriteria = {
	black: boolean,
	white: boolean,
	red: boolean,
	yellow: boolean,
	grey: boolean,
	blue: boolean,
}

type InteriorColorCriteria = {
	black: boolean,
	red: boolean,
	microfiber: boolean,
	tobacco: boolean,
}

type OptionsCriteria = {
	triCoat: boolean,
	cfRoof: boolean,
	cfHalo: boolean,
	akra: boolean,
}

type PackagesCriteria = {
	track: boolean,
	cfInterior: boolean,
}

type SearchCriteria = {
	body: BodyCriteria,
	edition: EditionCriteria,
	exteriorColor: ExteriorColorCriteria,
	interiorColor: InteriorColorCriteria,
	options: OptionsCriteria,
	packages: PackagesCriteria,
}

let search: SearchCriteria = {
	body: { coupe: false, spider: false },
	edition: { base: false, launchEdition: false, italia: false, stradaleTributo: false },
	exteriorColor: { black: false, white: false, red: false, yellow: false, grey: false, blue: false },
	interiorColor: { black: false, microfiber: false, red: false, tobacco: false },
	options: { triCoat: false, cfRoof: false, cfHalo: false, akra: false },
	packages: { track: false, cfInterior: false }
}

async function sendSearch() {
	const response = await fetch('/search', {
		method: 'POST',
		headers: { 'Content-type': 'application/json; charset=UTF-8' },
		body: JSON.stringify(search),
	});
	result = await response.json();	
}

/*
onMount(async () => {
	const response = await fetch('/search', {
		method: 'POST',
		headers: { 'Content-type': 'application/json; charset=UTF-8' },
		body: JSON.stringify(search),
	});
	result = await response.json();
});
*/
</script>

<div class="picture" />

<section>
	<div class="container">
		<div class="row mt-4">
			<div class="col-md-3">
				<div class="card p-2 shadow">
					<div class="card-body">
						<h5 class="card-title mb-4">Search cars</h5>
						<form>
							<div>
								<h6>Body</h6>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="body-coupe"
										bind:checked={search.body.coupe}
									/>
									<label
										class="form-check-label"
										for="body-coupe">Coupe</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="body-spider"
										bind:checked={search.body.spider}
									/>
									<label
										class="form-check-label"
										for="body-spider">Spider</label>
								</div>
							</div>
							<div>
								<h6>Edition</h6>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="edition-base"
										bind:checked={search.edition.base}
									/>
									<label
										class="form-check-label"
										for="edition-base">Base</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="edition-launch"
										bind:checked={search.edition.launchEdition}
									/>
									<label
										class="form-check-label"
										for="edition-launch">Launch Edition</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="edition-italia"
										bind:checked={search.edition.italia}
									/>
									<label
										class="form-check-label"
										for="edition-italia">Italia</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="edition-st"
										bind:checked={search.edition.stradaleTributo}
									/>
									<label
										class="form-check-label"
										for="edition-st">Stradale Tributo</label>
								</div>
							</div>
							<div>
								<h6>Exterior color</h6>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="color-black"
										bind:checked={search.exteriorColor.black}
									/>
									<label
										class="form-check-label"
										for="color-black">Black</label
									>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="color-white"
										bind:checked={search.exteriorColor.white}
									/>
									<label
										class="form-check-label"
										for="color-white">White</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="color-red"
										bind:checked={search.exteriorColor.red}
									/>
									<label
										class="form-check-label"
										for="color-red">Red</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="color-yellow"
										bind:checked={search.exteriorColor.yellow}
									/>
									<label
										class="form-check-label"
										for="color-yellow">Yellow</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="color-grey"
										bind:checked={search.exteriorColor.grey}
									/>
									<label
										class="form-check-label"
										for="color-grey">Grey</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="color-blue"
										bind:checked={search.exteriorColor.blue}
									/>
									<label
										class="form-check-label"
										for="color-grey">Blue</label>
								</div>
							</div>
							<div>
								<h6>Interior color</h6>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="int-black"
										bind:checked={search.interiorColor.black}
									/>
									<label
										class="form-check-label"
										for="int-black">Black</label
									>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="int-red"
										bind:checked={search.interiorColor.red}
									/>
									<label
										class="form-check-label"
										for="int-red">Red</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="int-mf"
										bind:checked={search.interiorColor.microfiber}
									/>
									<label
										class="form-check-label"
										for="int-mf">Microfiber</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="int-tobacco"
										bind:checked={search.interiorColor.tobacco}
									/>
									<label
										class="form-check-label"
										for="int-tobacoo">Tobacco</label>
								</div>
							</div>
							<div>
								<h6>Options</h6>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="opt-tricoat"
										bind:checked={search.options.triCoat}
									/>
									<label
										class="form-check-label"
										for="color-black">Tri-coat paint</label
									>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="opt-cf-roof"
										bind:checked={search.options.cfRoof}
									/>
									<label
										class="form-check-label"
										for="opt-cf-roof">Carbon fiber roof</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="opt-cf-halo"
										bind:checked={search.options.cfHalo}
									/>
									<label
										class="form-check-label"
										for="opt-cf-halo">Carbon fiber halo</label>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="opt-akra"
										bind:checked={search.options.akra}
									/>
									<label
										class="form-check-label"
										for="opt-akra">Akrapovic exhaust</label>
								</div>
							</div>
							<div>
								<h6>Packages</h6>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="pkg-track"
										bind:checked={search.packages.track}
									/>
									<label
										class="form-check-label"
										for="pkg-track">Track</label
									>
								</div>
								<div class="form-check m-2">
									<input
										class="form-check-input"
										type="checkbox"
										id="pkg-cf-interior"
										bind:checked={search.packages.cfInterior}
									/>
									<label
										class="form-check-label"
										for="pkg-cf-interior">Carbon fiber interior</label>
								</div>
							</div>
							<div>
								<button
									type="submit"
									class="btn btn-primary"
									on:click|preventDefault={sendSearch}>Search</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div class="col-md-9">
				<div class="card mb-3">
					<div class="card-body">
						<h5 class="card-title">Search results</h5>
						<p class="card-text">
							{#if result}
							Number of cars: {result.count}
							{/if}
						</p>
						<table class="table">
							{#if result}
							{#each result.vins as vin}
								<tr>
									<td>{vin}</td>
									<td><a href="https://www.chrysler.com/hostd/windowsticker/getWindowStickerPdf.do?vin={vin}">Window Sticker</a></td>
								</tr>
							{/each}
							{/if}
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
